import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { denormalisedResponseEntities } from '../../util/data';
import { currentUserShowSuccess } from '../../ducks/user.duck';
// algoliasearch is loaded lazily (see util/algoliaClient) so it is not shipped in
// the main bundle on every page — it is only needed when an Algolia request runs.
import { getAlgoliaClient } from '../../util/algoliaClient';
import { algoliaListingFacets } from '../../config/configDefault';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
export const ASSET_NAME = 'landing-page';
export const DISCOVERY_HOMEPAGE_ASSET_NAME = 'discovery-homepage';
const LANDING_PAGE_PROJECTS_COUNT = 5;

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/LandingPage/SET_INITIAL_STATE';

export const QUERY_PROJECTS_REQUEST = 'app/LandingPage/QUERY_PROJECTS_REQUEST';
export const QUERY_PROJECTS_SUCCESS = 'app/LandingPage/QUERY_PROJECTS_SUCCESS';
export const QUERY_PROJECTS_ERROR = 'app/LandingPage/QUERY_PROJECTS_ERROR';
export const ISFEATURED_PROJECTS_REQUEST = 'app/LandingPage/ISFEATURED_PROJECTS_REQUEST';
export const ISFEATURED_PROJECTS_SUCCESS = 'app/LandingPage/ISFEATURED_PROJECTS_SUCCESS';
export const ISFEATURED_PROJECTS_ERROR = 'app/LandingPage/ISFEATURED_PROJECTS_ERROR';

export const ADD_FAVORITE_REQUEST = 'app/LandingPage/ADD_FAVORITE_REQUEST';
export const ADD_FAVORITE_SUCCESS = 'app/LandingPage/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'app/LandingPage/ADD_FAVORITE_ERROR';
export const FACETS_REQUEST = 'app/LandingPage/FACETS_REQUEST';
export const FACETS_SUCCESS = 'app/LandingPage/FACETS_SUCCESS';
export const FACETS_ERROR = 'app/LandingPage/FACETS_ERROR';
// ================ Reducer ================ //
const ALGOLIA_CLIENT_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_ADMIN_API_KEY;
const ALGOLIA_PRIME_LISTINGS_INDEX = process.env.REACT_APP_ALGOLIA_LISTINGS_FAMILY_INDEX;
const initialState = {
  projectRefs: [],
  isFeatured:[],
  queryProjectsInProgress: false,
  queryProjectsError: null,
  facets:[],
};

export default function landingPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_STATE:
      return { ...initialState };

    
    case QUERY_PROJECTS_REQUEST:
      return {
        ...state,
        queryProjectsInProgress: true,
        queryProjectsError: null,
      };
    case QUERY_PROJECTS_SUCCESS:

      return {
        ...state,
        queryProjectsInProgress: false,
        projectRefs: payload.projectRefs,
      };
    case QUERY_PROJECTS_ERROR:
      return { ...state, projectRefs: [], queryProjectsError: payload };
          
    case ISFEATURED_PROJECTS_REQUEST:
      return {
        ...state,
        queryProjectsInProgress: true,
        queryProjectsError: null,
      };
    case ISFEATURED_PROJECTS_SUCCESS:

      return {
        ...state,
        queryProjectsInProgress: false,
        isFeatured: payload.projectRefs,
      };
    case ISFEATURED_PROJECTS_ERROR:
      return { ...state, isFeatured: [], queryProjectsError: payload };
      case FACETS_REQUEST:
        return {
          ...state,
          facetsInProgress: true,
          facetsError: null,
        };
      case FACETS_SUCCESS:
        return {
          ...state,
          facetsInProgress: false,
          facets: payload,
        };
      case FACETS_ERROR:
        return {
          ...state,
          facetsInProgress: false,
          facetsError: payload
        };
    default:
      return state;
  }
}
export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});
export const queryProjectsRequest = () => ({
  type: QUERY_PROJECTS_REQUEST,
});

export const queryProjectsSuccess = projectRefs => ({
  type: QUERY_PROJECTS_SUCCESS,
  payload: { projectRefs },
});

export const queryProjectsError = e => ({
  type: QUERY_PROJECTS_ERROR,
  error: true,
  payload: e,
});
export const queryIsFeaturedListingRequest = () => ({
  type: ISFEATURED_PROJECTS_REQUEST,
});

export const queryIsFeaturedListingSuccess = projectRefs => ({
  type: ISFEATURED_PROJECTS_SUCCESS,
  payload: { projectRefs },
});
export const queryIsFeaturedListingError = e => ({
  type: ISFEATURED_PROJECTS_ERROR,
  error: true,
  payload: e,
});
export const addFavoriteRequest = () => ({
  type: ADD_FAVORITE_REQUEST,
});

export const addFavoriteSuccess = result => ({
  type: ADD_FAVORITE_SUCCESS,
  payload: result.data,
});

export const addFavoriteError = error => ({
  type: ADD_FAVORITE_ERROR,
  error: true,
  payload: error,
});
// Algolia facets
export const algoliaFacetsRequest = () => ({
  type: FACETS_REQUEST
});

export const algoliaFacetsSuccess = (facets) => ({
  type: FACETS_SUCCESS,
  payload: facets
});
export const queryProjects = (config) => (dispatch, getState, sdk) => {
  dispatch(queryProjectsRequest());
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;
  return sdk.listings
    .query({
      perPage: LANDING_PAGE_PROJECTS_COUNT,
      include: ['author', 'images','author.profileImage'],
      // 'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
      'fields.user': ['profile', 'profile.abbreviatedName', 'profile.publicData'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
        'variants.square-small', 
        'variants.square-small2x'
      ],
      // 'fields.image': ['variants.square-small', 'variants.square-small2x'],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    })
    .then(response => {
      const projectRefs = response.data.data.map(l => l.id);
      dispatch(addMarketplaceEntities(response));
      dispatch(queryProjectsSuccess(projectRefs));

      return response;
    })
    .catch(e => dispatch(queryProjectsError(storableError(e))));
};
export const queryIsFeaturedListing = (config) => (dispatch, getState, sdk) => {
  dispatch(queryIsFeaturedListingRequest());
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;
  return sdk.listings
    .query({
      perPage: LANDING_PAGE_PROJECTS_COUNT,
      pub_isFeaturedListing: true,
      include: ['author', 'images','author.profileImage'],
      // 'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
      'fields.user': ['profile', 'profile.abbreviatedName', 'profile.publicData'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
        'variants.square-small', 
        'variants.square-small2x'
      ],
      // 'fields.image': ['variants.square-small', 'variants.square-small2x'],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    })
    .then(response => {
      const projectRefs = response.data.data.map(l => l.id);
      dispatch(addMarketplaceEntities(response));
      dispatch(queryIsFeaturedListingSuccess(projectRefs));

      return response;
    })
    .catch(e => dispatch(queryIsFeaturedListingError(storableError(e))));
};
export const toggleFavorite = (favoriteId) => (dispatch, getState, sdk) => {
  dispatch(addFavoriteRequest());

  const { currentUser } = getState().user;
  if (!currentUser || !currentUser.id) {
    dispatch(addFavoriteError(new Error('User not authenticated')));
    return Promise.reject(new Error('User not authenticated'));
  }

  const currentFavorites = currentUser.attributes?.profile?.publicData?.favorites || [];
  const isFavorite = currentFavorites.includes(favoriteId);
  
  const updatedFavorites = isFavorite
    ? currentFavorites.filter(id => id !== favoriteId)
    : [...currentFavorites, favoriteId];

  return updateProfile({
    publicData: {
      favorites: updatedFavorites,
    },
  })
    .then(response => {
      dispatch(addFavoriteSuccess(response));

      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      const updatedUser = entities[0];

      // Update current user in state.user.currentUser through user.duck.js
      dispatch(currentUserShowSuccess(updatedUser));
      return updatedUser;
    })
    .catch(e => {
      dispatch(addFavoriteError(storableError(e)));
      throw e;
    });
};
export const getFacets = (params) => async (dispatch, getState, sdk) => {
  dispatch(algoliaFacetsRequest());
  const searchClient = await getAlgoliaClient(ALGOLIA_CLIENT_ID, ALGOLIA_API_KEY);
  const listings = ALGOLIA_PRIME_LISTINGS_INDEX;
  const listingIndex = searchClient.initIndex(listings);
  return listingIndex.search('', {
    facets: algoliaListingFacets,
  })
    .then(({ facets }) => {
      const labeledFacets = getLabeledFacets(facets);
      dispatch(algoliaFacetsSuccess(labeledFacets));
      return facets;
    })
    .catch(err => {
      dispatch(algoliaFacetsError(err))
    });
};
export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { isAuthenticated, } = getState().auth;
  // If user is not logged in, use default landing page asset.
  // If user is logged in, use discovery homepage asset.
  const assetName = isAuthenticated ? DISCOVERY_HOMEPAGE_ASSET_NAME : ASSET_NAME;

  const pageAsset = { landingPage: `content/pages/${assetName}.json` };

  return Promise.all([
    dispatch(queryProjects(config)),
    dispatch(queryIsFeaturedListing(config)),
    dispatch(fetchPageAssets(pageAsset, true)),
  ]);
};
